import * as React from 'react';

const Dots = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={18} height={6} viewBox="0 0 18 6" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            transform="translate(1 1)"
        >
            <circle cx={2.25} cy={2.015} r={1.75} />
            <circle cx={13.75} cy={2.015} r={1.75} />
            <circle cx={8} cy={2.015} r={1.75} />
        </g>
    </svg>
);
export default Dots;
